import React from 'react'
import { useIntl } from 'react-intl'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'

export type LocationProps = {
  startLocation?: string | null
  endLocation?: string | null
  typeOfExperience?: string
  variant?: 'single' | 'start_and_end' | 'with_experience'
}

function TourV2Location(props: LocationProps) {
  const { endLocation, startLocation, typeOfExperience, variant = 'single' } = props
  const intl = useIntl()

  const startsEndsInLabel = intl.formatMessage(
    {
      id: 'fBeh124qft',
      defaultMessage: 'Starts in {startLocation}, Ends in {endLocation}',
      description: 'Tour location label showing distinct start and end locations',
    },
    { startLocation, endLocation },
  )

  return (
    <Group direction="horizontal" verticalAlign="center" gap={4}>
      {variant === 'single' && (
        <Caption variant="large" colour="neutral-one">
          {startLocation}
        </Caption>
      )}
      {variant === 'start_and_end' && (
        <Caption variant="large" colour="neutral-one">
          {startsEndsInLabel}
        </Caption>
      )}
      {variant === 'with_experience' && (
        <Caption variant="large" colour="neutral-one">
          {startLocation}
          {typeOfExperience && (
            <Caption as="span" variant="large" colour="neutral-two">
              {` · ${typeOfExperience}`}
            </Caption>
          )}
        </Caption>
      )}
    </Group>
  )
}
export default TourV2Location
